module.exports = __webpack_public_path__ + "img/ICONE-POINTS.1a0b02ba.svg";